var render = function render(){
  var _vm$selectedData, _vm$selectedData2, _vm$selectedData3, _vm$selectedData4, _vm$selectedData5, _vm$selectedData5$use, _vm$selectedData5$use2, _vm$selectedData6, _vm$selectedData6$use, _vm$selectedData6$use2, _vm$selectedData7, _vm$selectedData7$use, _vm$selectedData7$use2, _vm$selectedData7$use3, _vm$selectedData$desc, _vm$selectedData8;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    staticClass: "p-3",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [!_vm.selectedData ? _c('b-row', [_c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "mb-1"
  }, [_vm._v("Fleet "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('v-select', {
    attrs: {
      "options": _vm.fleetOptions,
      "label": "name",
      "reduce": function reduce(option) {
        return option === null || option === void 0 ? void 0 : option.id;
      }
    },
    on: {
      "input": _vm.fetchVehiclePowerList
    },
    model: {
      value: _vm.dataForm.vehicleId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "vehicleId", $$v);
      },
      expression: "dataForm.vehicleId"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "mb-1"
  }, [_vm._v("Effective Date "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('date-picker', {
    staticClass: "w-100",
    attrs: {
      "type": "date",
      "placeholder": "Select time",
      "format": "DD-MM-YYYY",
      "value-type": "DD-MM-YYYY",
      "disabled-date": _vm.disableAfterToday
    },
    model: {
      value: _vm.dataForm.effectiveDate,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "effectiveDate", $$v);
      },
      expression: "dataForm.effectiveDate"
    }
  })], 1), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('label', {
    staticClass: "mb-1"
  }, [_vm._v("Description")]), _c('b-textarea', {
    model: {
      value: _vm.dataForm.description,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "description", $$v);
      },
      expression: "dataForm.description"
    }
  })], 1)], 1) : _c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    staticClass: "mb-3",
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "md": "4"
    }
  }, [_vm._v("Transaction Type")]), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_vm._v("Adjustment")]), _c('b-col', {
    staticClass: "mb-3",
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "md": "4"
    }
  }, [_vm._v("Request Date")]), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_vm._v(_vm._s((_vm$selectedData = _vm.selectedData) !== null && _vm$selectedData !== void 0 && _vm$selectedData.created_at ? _vm.formateDate((_vm$selectedData2 = _vm.selectedData) === null || _vm$selectedData2 === void 0 ? void 0 : _vm$selectedData2.created_at) : '-'))]), _c('b-col', {
    staticClass: "mb-3",
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "md": "4"
    }
  }, [_vm._v("Effective Date")]), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_vm._v(_vm._s((_vm$selectedData3 = _vm.selectedData) !== null && _vm$selectedData3 !== void 0 && _vm$selectedData3.effective_date ? _vm.formateDate((_vm$selectedData4 = _vm.selectedData) === null || _vm$selectedData4 === void 0 ? void 0 : _vm$selectedData4.effective_date) : '-'))]), _c('b-col', {
    staticClass: "mb-3",
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "md": "4"
    }
  }, [_vm._v("Creator")]), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "8"
    }
  }, [_c('UserTemplate', {
    attrs: {
      "userDetail": {
        name: (_vm$selectedData5 = _vm.selectedData) === null || _vm$selectedData5 === void 0 ? void 0 : (_vm$selectedData5$use = _vm$selectedData5.user) === null || _vm$selectedData5$use === void 0 ? void 0 : (_vm$selectedData5$use2 = _vm$selectedData5$use.requestor) === null || _vm$selectedData5$use2 === void 0 ? void 0 : _vm$selectedData5$use2.name,
        photo: (_vm$selectedData6 = _vm.selectedData) === null || _vm$selectedData6 === void 0 ? void 0 : (_vm$selectedData6$use = _vm$selectedData6.user) === null || _vm$selectedData6$use === void 0 ? void 0 : (_vm$selectedData6$use2 = _vm$selectedData6$use.requestor) === null || _vm$selectedData6$use2 === void 0 ? void 0 : _vm$selectedData6$use2.photo,
        position: (_vm$selectedData7 = _vm.selectedData) === null || _vm$selectedData7 === void 0 ? void 0 : (_vm$selectedData7$use = _vm$selectedData7.user) === null || _vm$selectedData7$use === void 0 ? void 0 : (_vm$selectedData7$use2 = _vm$selectedData7$use.detail) === null || _vm$selectedData7$use2 === void 0 ? void 0 : (_vm$selectedData7$use3 = _vm$selectedData7$use2.department) === null || _vm$selectedData7$use3 === void 0 ? void 0 : _vm$selectedData7$use3.name
      }
    }
  })], 1), _c('b-col', {
    staticClass: "mb-3",
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "md": "4"
    }
  }, [_vm._v("Description")]), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_vm._v(_vm._s((_vm$selectedData$desc = (_vm$selectedData8 = _vm.selectedData) === null || _vm$selectedData8 === void 0 ? void 0 : _vm$selectedData8.description) !== null && _vm$selectedData$desc !== void 0 ? _vm$selectedData$desc : '-'))])], 1), _c('table', {
    staticClass: "w-100 table-striped"
  }, [_c('thead', [_c('th', [_vm._v(" ENGINE NAME ")]), _c('th', [_vm._v("CURRENT TOTAL")]), !_vm.selectedData ? _c('th', [_vm._v("HOURS")]) : _vm._e(), _vm.selectedData ? _c('th', [_vm._v("Transaction")]) : _vm._e(), _c('th', [_vm._v("TO BE TOTAL")])]), _vm.loading ? _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading...")], 1)])]) : _vm.dataForm.runningHours && _vm.dataForm.runningHours.length ? _c('tbody', [_vm._l(_vm.dataForm.runningHours, function (item, i) {
    var _item$powerType;
    return [_c('tr', {
      key: i
    }, [_c('td', [_vm._v(_vm._s((_item$powerType = item === null || item === void 0 ? void 0 : item.powerType) !== null && _item$powerType !== void 0 ? _item$powerType : '-'))]), !_vm.selectedData ? _c('td', [_vm._v(_vm._s(_vm.toHourMinute(item === null || item === void 0 ? void 0 : item.totalMinutes)))]) : _c('td', [_vm._v(_vm._s(_vm.toHourMinute(((item === null || item === void 0 ? void 0 : item.totalRunningHour) || 0) - ((item === null || item === void 0 ? void 0 : item.running_minutes) || 0))))]), !_vm.selectedData ? _c('td', {
      staticClass: "d-flex px-2",
      staticStyle: {
        "width": "100px"
      }
    }, [_c('b-form-input', {
      staticClass: "mr-1 text-right bg-white",
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "placeholder": "00",
        "type": "number"
      },
      model: {
        value: item.hour,
        callback: function callback($$v) {
          _vm.$set(item, "hour", $$v);
        },
        expression: "item.hour"
      }
    })], 1) : _vm._e(), _vm.selectedData ? _c('td', [_vm._v(" " + _vm._s(_vm.toHourMinute(item.running_minutes)) + " ")]) : _vm._e(), !_vm.selectedData ? _c('td', [_vm._v(_vm._s(_vm.toHourMinute(_vm.toMinutes(item.hour || 0, item.min || 0) + item.totalMinutes || 0)))]) : _c('td', [_vm._v(" " + _vm._s(_vm.toHourMinute(item.totalRunningHour || 0)) + " ")])])];
  })], 2) : _c('tbody', [_vm._m(0)])]), !_vm.selectedData ? _c('div', {
    staticClass: "d-flex mt-4"
  }, [_c('b-button', {
    staticClass: "w-50 mr-3",
    attrs: {
      "variant": "outline-primary",
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("Cancel")]), !_vm.loadingSubmit ? _c('b-button', {
    staticClass: "w-50",
    attrs: {
      "variant": "primary",
      "type": "submit"
    }
  }, [_vm._v("Submit")]) : _c('b-button', {
    staticClass: "w-50 d-flex align-items-center justify-content-center",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }), _vm._v(" Saving...")], 1)], 1) : _c('div', [_c('b-button', {
    staticClass: "w-100 mt-3",
    attrs: {
      "variant": "outline-primary",
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("Close")])], 1)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Not Found Running History")])]);

}]

export { render, staticRenderFns }